<template>
  <div class="register">
    <div>
      <div class="logo_register">
        <v-btn class="logo__not_hover" text tile to="/">
          <img alt src="img/icons/logo_v3.svg" />
        </v-btn>
      </div>
      <p class="register_title">Iniciar Registro</p>
      <p class="register_desc">
        Empieza tu período de prueba de <b>30 días gratis</b>
      </p>
      <div ref="form">
        <v-text-field
          :rules="[() => !!name || 'Te falto escribir tu nombre.']"
          autofocus
          color="#42a5f5"
          label="Nombre completo"
          outlined
          ref="name"
          required
          type="text"
          v-model="name"
        ></v-text-field>
        <v-text-field
          :rules="emailRules"
          color="#42a5f5"
          label="Correo electrónico"
          outlined
          ref="email"
          required
          type="email"
          v-model="email"
        ></v-text-field>
        <v-text-field
          :rules="rulesPass"
          color="#42a5f5"
          label="Contraseña"
          outlined
          ref="password"
          required
          type="password"
          v-model="password"
        ></v-text-field>
        <div class="register_btn">
          <!-- <v-btn @click="submit" class="login" color="blue">CREAR TU ESPACIO</v-btn> -->
          <!-- se documento para la version beta -->
          <v-btn class="register__action" color="#000">Registrarse</v-btn>
        </div>
      </div>
      <div class="register_new">
        <p>¿ya tienes una cuenta lubumas?</p>
        <v-btn text to="/signin">inicia sesión</v-btn>
      </div>
      <v-alert class="alert-md" color="red" text v-if="errmensaje">{{
        errmensaje
      }}</v-alert>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'register',
  data() {
    return {
      email: null,
      emailRules: [
        (v) => !!v || 'El correo electrónico es requerido.',
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'El formato no es valido',
      ],
      name: null,
      password: null,
      rulesPass: [
        (v) => !!v || 'La contraseña es requerida.',
        (v) =>
          (v && v.length >= 8) ||
          'La contraseña no puede ser inferior a 8 caracteres.',
      ],
      errmensaje: null,
      errorMessages: '',
      formHasErrors: false,
    }
  },
  watch: {
    name() {
      this.errorMessages = ''
    },
  },
  methods: {
    submit() {
      this.formHasErrors = false

      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) this.formHasErrors = true

        this.$refs[f].validate(true)
      })
      if (this.formHasErrors == false) {
        this.registerUser()
      }
    },
    registerUser() {
      const params = new URLSearchParams()
      params.append('email', this.email)
      params.append('name', this.name)
      params.append('password', this.password)
      axios
        .post('user/signup', params)
        .then((response) => {
          // console.log(response.data);
          //console.log(response.data);
          return response.data
        })
        .then((data) => {
          //console.log("ingreso", data);
          this.$store.dispatch('saveToken', data.tokenReturn)
          this.$router.push({ name: 'control' }).catch((err) => {})
        })
        .catch((error) => {
          //console.log(this.email, this.password);
          //this.errmensaje = null;
          //console.log("el error es", error.response.status);
          if (error.response.status == 404) {
            this.errmensaje =
              'Usuario y/o contraseña invalidos' + error.response.data
          } else {
            this.errmensaje = 'Ops! ocurrio un error con el servidor'
            //console.log(error);
          }
          //console.log(error);
        })
    },
  },
  computed: {
    form() {
      return {
        name: this.name,
        email: this.email,
        password: this.password,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/base.scss';
.register {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  width: 100%;
  min-height: 100vh;
  @media #{$tablet-up} {
    width: 410px;
  }

  .logo_register {
    margin-bottom: 10px;
    svg,
    img {
      height: 40px;
      width: 140px;
    }
    .logo__not_hover {
      &::before {
        background: transparent;
      }
    }
  }
  p {
    margin: 0;
    &.register_title {
      font-weight: 600;
      font-size: 26px;
      color: $color-text;
    }
    &.register_desc {
      font-size: 1rem;
      color: $color-text;
      margin-bottom: 10px;
      b {
        text-transform: uppercase;
        color: $btn-primary-color;
      }
    }
  }
  .register_reset {
    color: $link-color;
    margin-left: auto;
    font-size: 13px;
    margin-bottom: 5px;
    @media #{$tablet-up} {
      padding-left: 5px;
      padding-right: 5px;
      font-size: 12px;
    }
  }
  .register_btn {
    display: block;
    .register__action {
      color: #fff;
      width: 50%;
      height: 40px;
    }
  }
  .register_new {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    p {
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      // text-transform: uppercase;
      font-size: 0.9rem;
      b {
        color: $btn-primary-color;
      }
    }
    a {
      color: $color-text;
      //padding-left: 5px;
      text-transform: none;
      padding: 0;
      font-size: 0.9rem;
      &:hover {
        //color: #000;
        color: $btn-primary-color;
        text-decoration: underline;
      }
      &::before {
        background: transparent !important;
      }

      @media #{$tablet-up} {
        //font-size: 12px;
      }
    }
  }
}
</style>
